import { DBConstants } from '../../_constants';

export function DB(state = {}, action) {
    switch (action.type) {
        case DBConstants.FETCHING:
            return {
                ...state,
                DBfetching: true
            };
        case DBConstants.FETCHED:
            return {
                ...state,
                DBfetching: false
            };
        case DBConstants.GET_DB:
            return {
                ...state,
                DB: action.DB,
                DBSelection: true
            };
        default:
            return state;
    }
}